// extracted by mini-css-extract-plugin
export default {"activateButtonContainer":"EU1dm3hEB8"};